import React, { useState } from "react";
import "./footer.css";
// import Modal from "react-modal";
// import InstagramEmbed from "react-instagram-embed";

export const Footer = () => {
  // const [isOpen, setIsOpen] = useState(false);
  // const handleModalClose = () => {
  //   setIsOpen(false);
  // };

  return (
    <footer>
      <div className="footer">
        <div className="row">
          <a href="#">
            <i className="fa fa-facebook"></i>
          </a>
          <a
            href="https://www.instagram.com/rivadaviactes104.1/?igshid=YmMyMTA2M2Y%3D"
            target="_blank"
          >
            <i className="fa fa-instagram"></i>
          </a>
          <a href="#">
            <i className="fa fa-youtube"></i>
          </a>
          <a href="#">
            <i className="fa fa-twitter"></i>
          </a>
        </div>

        <div className="row">
          <ul>
            <li>
              <a href="#">Contacto</a>
            </li>
            <li>
              <a href="#">Programación</a>
            </li>
            <li>
              <a href="#">Politica de Privacidad</a>
            </li>
            <li>
              <a href="#">Nosotros</a>
            </li>
          </ul>
        </div>

        <div className="row">
          RadioRivadavia Copyright © 2023 RadioRivadavia - All rights reserved
        </div>
      </div>
    </footer>
  );
};
